/**
 * 地図の actions
 */
const actions = {

  /**
   * 地図を初期化します
   * @param {*} commit
   * @param {Object} payload
   * @param {Object} state
   */
  init: ({commit, state}, payload) => {
    if (state.map) {
      // TODO: 初期化する際の動作を検討
      commit('removeMap');
    }
    commit('init', payload);
  },

  /**
   * ズームアップします
   * @param {*} commit
   */
  zoomUp: ({commit}) => {
    commit('zoomUp');
  },

  /**
   * ズームダウンします
   * @param {*} commit
   */
  zoomDown: ({commit}) => {
    commit('zoomDown');
  },

  /**
   * 中心を移動します
   * @param {*} commit
   * @param {Object} payload
   */
  panTo: ({commit}, payload) => {
    commit('panTo', payload);
  },

  /**
   * 緯度経度の配列を含むように縮尺と中心を調整します
   * @param {*} commit
   * @param {Object} payload
   */
  setFocus: ({commit}, payload) => {
    commit('setFocus', payload);
  },

  /**
   * 地図表示領域のリサイズを行います
   * @param {*} commit
   * @param {Object} payload
   */
  resize: ({commit}, payload) => {
    commit('resize', payload);
  },

  /**
   * ピンを追加します
   * @param {*} commit
   * @param {Object} payload
   */
  addPin: ({commit}, payload) => {
    commit('addPin', payload);
  },

  /**
   * (使用非推奨)ピンを追加します
   * @param {*} commit
   * @param {Object} payload
   */
  addPins: ({commit}, payload) => {
    commit('addPins', payload);
  },

  /**
   * model/spot 形式のスポット情報を配列で受け取り、
   * 現在地を表すスポット用ピンを地図に追加します
   * @param {*} commit
   * @param {Object} payload
   */
  addUserCurrentLocationPinBySpot: ({commit}, payload) => {
    commit('addUserCurrentLocationPinBySpot', payload);
  },

  /**
   * 指定したピンを削除します
   * @param {*} commit
   * @param {Object} payload
   */
  removePin: ({commit}, payload) => {
    commit('removePinFromAction', payload);
  },

  /**
   * 指定した種別のピンを削除します
   * @param {*} commit
   * @param {Object} payload
   */
  removePins: ({commit}, payload) => {
    commit('removePins', payload);
  },

  /**
   * ポリラインを追加します
   * @param {*} commit
   * @param {Object} payload
   */
  addPolyline: ({commit}, payload) => {
    commit('addPolyline', payload);
  },

  /**
   * 指定したIDのポリラインを削除します
   * @param {*} commit
   * @param {Object} payload
   */
  removePolyline: ({commit}, payload) => {
    commit('removePolyline', payload);
  },

  /**
   * 吹き出しを表示します
   */
  setInfoWindow: ({commit}, payload) => {
    commit('setInfoWindow', payload);
  },

  /**
   * 指定した吹き出しを削除します
   */
  deleteInfoWindow: ({commit}, payload) => {
    commit('deleteInfoWindow', payload);
  },

  /**
   * /map画面で表示するタブを指定します
   */
  setSelectedSpotTab: ({ commit }, payload) => {
    commit('selectedSpotTab', payload);
  },

  setCenterOffset: ({commit, state}, payload) => {
    commit('setCenterOffset', payload);
  },
};

export {actions as default};
